import moment from "moment";
import { OrganizationState } from "go-security/services/organizations/types";
import { LiveOrderApi } from "../../../../../../../services/Api/Organization/types";
import { isWoltDriveAssigned } from "./orderDelivery";
import { LiveOrderDeliveryOptionType } from "./types";

export const getLiveOrderNumber = (order: LiveOrderApi) => {
	if (order?.source?.number && order.number !== order?.source?.number) {
		return `#${order.source.number} - ${order.number}`;
	}
	return `#${order.number}`;
};

export const isWoltDriveEnabled = (organization: OrganizationState) =>
	(organization.more.installed_app_providers || []).find((appProvider: string) => appProvider === "WOLT_DRIVE");

export const getDefaultDeliveryOption = (organization: OrganizationState, order: LiveOrderApi) => {
	if (isWoltDriveEnabled(organization)) {
		if (isWoltDriveAssigned(order)) return LiveOrderDeliveryOptionType.WOLT_DRIVE;
		if (order.delivery?.delivery_employee?.reference_id || order.delivery?.delivery_employee?.id)
			return LiveOrderDeliveryOptionType.OWN_DRIVER;
		return undefined;
	}
	return LiveOrderDeliveryOptionType.OWN_DRIVER;
};

export const getNumberOfMinutesFromNowToTheDate = (targetDateAsString?: string | Date): number => {
	if (!targetDateAsString) return 0;

	const targetDate = new Date(targetDateAsString).getTime();
	const differenceInMilliseconds = targetDate - Date.now();
	const currentDateIsTheDateAfterTheTargetDate = differenceInMilliseconds < 0;

	if (currentDateIsTheDateAfterTheTargetDate) return 0;

	const resultAsMinutes = moment.duration(differenceInMilliseconds).asMinutes();

	return Math.trunc(resultAsMinutes);
};

export const getValidOrderTransactions = (order?: LiveOrderApi) => {
	return (order?.transactions || []).filter(
		(transaction) =>
			(transaction.status === "SUCCESS" || transaction.status === "OPEN" || transaction.status === "NEW") &&
			transaction.type === "PAY_IN" &&
			transaction.attached
	);
};
